import { Stack } from '@mui/material';

interface SpacerProps {
    padding: number | string;
}

const Spacer = ({ padding }: SpacerProps) => {
    return <Stack p={padding} />;
};

export default Spacer;
